import { css } from '@emotion/react'
import { Button, HFlow, Icon, Text, Tooltip, VFlow } from 'bold-ui'
import { VulnerabilidadeFamiliar } from 'graphql/types.generated'
import { Fragment, useState } from 'react'

import { CriteriosVulnerabilidadeFamiliarModal } from './CriteriosVulnerabilidadeFamiliarModal'
import { VulnerabilidadeFamiliarResult } from './VulnerabilidadeFamiliarResult'

interface VulnerabilidadeFamiliarFolhaRostoPanelProps {
  vulnerabilidadeFamiliar: VulnerabilidadeFamiliar
}

export const VulnerabilidadeFamiliarFolhaRostoPanel = ({
  vulnerabilidadeFamiliar,
}: Readonly<VulnerabilidadeFamiliarFolhaRostoPanelProps>) => {
  const styles = createStyles()
  const [modalOpen, setModalOpen] = useState(false)

  const { classificacao, grauSugestivo, escore, classificacaoSubestimada, criterios } = vulnerabilidadeFamiliar
  const { criteriosInequivocos, criteriosSugestivos } = criterios
  const hasCriterios = criteriosInequivocos.length > 0 || criteriosSugestivos.length > 0

  return (
    <Fragment>
      {hasCriterios && (
        <CriteriosVulnerabilidadeFamiliarModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          criterios={criterios}
        />
      )}
      <VFlow vSpacing={0.25}>
        <HFlow hSpacing={0.5} alignItems='center' justifyContent='space-between'>
          <HFlow hSpacing={0.5} alignItems='center'>
            <Icon icon='multipleUsers' size={1.25} />
            <Text fontWeight='bold'>Vulnerabilidade familiar</Text>
          </HFlow>
          <Tooltip text='Critérios de vulnerabilidade familiar'>
            <Button size='small' skin='ghost' disabled={!hasCriterios} onClick={() => setModalOpen(true)}>
              <Icon icon='zoomOutline' />
            </Button>
          </Tooltip>
        </HFlow>
        <div css={styles.indented}>
          <VulnerabilidadeFamiliarResult
            classificacao={classificacao}
            escore={escore}
            grauSugestivo={grauSugestivo}
            classificacaoSubestimada={classificacaoSubestimada}
          />
        </div>
      </VFlow>
    </Fragment>
  )
}

const createStyles = () => ({
  indented: css`
    padding-left: 1.5rem;
  `,
})
